import header from 'i18n/default/nl_NL/header.json';
import mainMenu from 'i18n/default/nl_NL/mainMenu.json';
import pendingPaymentAdvice from 'i18n/default/nl_NL/pendingPaymentAdvice.json';
import PalletType from 'i18n/default/nl_NL/PalletType.json';
import LiteralCurrency from 'i18n/default/nl_NL/LiteralCurrency';
import units from 'i18n/default/nl_NL/units';
import CustomPalletSize from 'i18n/default/nl_NL/CustomPalletSize';
import NumberOfItems from 'i18n/default/nl_NL/NumberOfItems';
import LoadInfo from 'i18n/default/nl_NL/LoadInfo';
import dates from 'i18n/default/nl_NL/dates';
import AddressFormModal from 'i18n/default/nl_NL/AddressFormModal';
import Addresses from 'i18n/default/nl_NL/Addresses';
import AddressSelector from 'i18n/default/nl_NL/AddressSelector';
import StopAddress from 'i18n/default/nl_NL/StopAddress';
import Quote from 'i18n/default/nl_NL/Quote';
import extraNames from 'i18n/default/nl_NL/extraNames';
import timePickers from 'i18n/default/nl_NL/timePickers';
import authLoginForm from 'i18n/default/nl_NL/authLoginForm';
import authSignUpForm from 'i18n/default/nl_NL/authSignUpForm';
import HandlingExtra from 'i18n/default/nl_NL/HandlingExtra';
import Stop from 'i18n/default/nl_NL/Stop';
import VehicleExtras from 'i18n/default/nl_NL/VehicleExtras';
import OrderStop from 'i18n/default/nl_NL/OrderStop';
import ShipmentCard from 'i18n/default/nl_NL/ShipmentCard';
import Orders from 'i18n/default/nl_NL/Orders';
import Summary from 'i18n/default/nl_NL/Summary';
import Login from 'i18n/default/nl_NL/Login';
import AddressesPage from 'i18n/default/nl_NL/AddressesPage';
import ModalSummary from 'i18n/default/nl_NL/ModalSummary';
import OrderSummary from 'i18n/default/nl_NL/OrderSummary';
import OrdersOrderDetail from 'i18n/default/nl_NL/OrdersOrderDetail';
import Order from 'i18n/default/nl_NL/Order';
import ModalOrderDetail from 'i18n/default/nl_NL/ModalOrderDetail';
import loads from 'i18n/default/nl_NL/loads';
import SuggestedTimes from 'i18n/default/nl_NL/SuggestedTimes';
import Downloads from 'i18n/default/nl_NL/Downloads';
import CreditCard from 'i18n/default/nl_NL/CreditCard';
import TypeOfOrderSelector from 'i18n/default/nl_NL/TypeOfOrderSelector';
import Recurring from 'i18n/default/nl_NL/Recurring';
import Settings from 'i18n/default/nl_NL/Settings';
import InviteUserModal from 'i18n/default/nl_NL/InviteUserModal';
import DriverMapError from 'i18n/default/nl_NL/DriverMapError';
import PaymentData from 'i18n/default/nl_NL/PaymentData';
import Faqs from 'i18n/default/nl_NL/Faqs';
import AdditionalDocuments from 'i18n/default/nl_NL/AdditionalDocuments';
import Communications from 'i18n/default/nl_NL/Communications';
import RecurringOrderSuggestions from 'i18n/default/nl_NL/RecurringOrderSuggestions';
import Error from 'i18n/default/nl_NL/Error';
import Users from 'i18n/default/nl_NL/Users';
import Tracking from 'i18n/default/nl_NL/Tracking';
import Profile from 'i18n/default/nl_NL/Profile';
import Landing from 'i18n/default/nl_NL/Landing';

const lang = {
  header,
  mainMenu,
  pendingPaymentAdvice,
  PalletType,
  LiteralCurrency,
  units,
  CustomPalletSize,
  NumberOfItems,
  LoadInfo,
  dates,
  AddressFormModal,
  AddressSelector,
  StopAddress,
  Quote,
  extraNames,
  timePickers,
  authLoginForm,
  authSignUpForm,
  HandlingExtra,
  Stop,
  VehicleExtras,
  OrderStop,
  ShipmentCard,
  Orders,
  Summary,
  Login,
  AddressesPage,
  ModalSummary,
  OrderSummary,
  Order,
  OrdersOrderDetail,
  ModalOrderDetail,
  loads,
  SuggestedTimes,
  Downloads,
  CreditCard,
  Addresses,
  TypeOfOrderSelector,
  Recurring,
  Settings,
  InviteUserModal,
  DriverMapError,
  PaymentData,
  Faqs,
  AdditionalDocuments,
  Communications,
  RecurringOrderSuggestions,
  Error,
  Users,
  Tracking,
  Profile,
  Landing
};

export default lang;
